module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "mavri.39bc1a74.jpg";